export function pipe(...fns: any) {
  return (arg: any) => fns.reduce((prev: any, fn: any) => fn(prev), arg);
}
